import { render, staticRenderFns } from "./SpeedTransitionPage.vue?vue&type=template&id=2b9be214&scoped=true&"
import script from "./SpeedTransitionPage.vue?vue&type=script&lang=js&"
export * from "./SpeedTransitionPage.vue?vue&type=script&lang=js&"
import style0 from "./SpeedTransitionPage.vue?vue&type=style&index=0&id=2b9be214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9be214",
  null
  
)

export default component.exports